export default __webpack_public_path__ + "static/media/kyc-woman.1c895697.png";